import { t } from "i18next"
import React, { useCallback, useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router"
import { useHistory } from "react-router-dom"
import { sortCaret } from "../../../../_metronic/_helpers"
import { CardBody } from "../../../../_metronic/_partials/controls"
import { useSubheader } from "../../../../_metronic/layout"
import { EmptyCard, Search, TableSkeleton, TableView } from "../../../../component"
import { formatterRowComponent, initialFilterTable } from "../../../../component/atoms/Tabel"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import {
  getListAssignOpsAdmin,
  getRegionalHeadDetailByRegionalId
} from "../../../../redux/actions/FieldOfficerAction.jsx"
import { stringFormatting } from "../../../helpers/TextHelper"
import { useUrlParam } from "../../../hooks/useUrlParams.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { Popup } from "../../../../component/atoms/Popup/index.jsx"
import { FIELD_OFFICER } from "../../../../constants/InitTypeConstants.js"

export function AssignOpsAdminListPage() {
  const subheader = useSubheader()
  const dispatch = useDispatch()
  const urlParams = useUrlParam()
  const location = useLocation()
  const history = useHistory()
  const user = loadUserLogin()
  const { regional } = useParams()
  const regionalId = regional || user?.regional_id
  const { FieldOfficer, General } = useSelector((state) => state)

  const [dataList, setDataList] = useState([])
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const [search, setSearch] = useState({ keyword: "" })
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [dataRh, setDataRh] = useState(undefined)
  const [showFOPopup, setShowFOPopup] = useState(false)
  const [selectedSubRegional, setSelectedSubRegional] = useState(undefined)
  const [listFO, setListFO] = useState([])

  useEffect(() => {
    subheader.setTitle(t("sub_header_ops_team"))
    dispatch(getRegionalHeadDetailByRegionalId(regionalId))
    subheader.setButton(null)
    if (!user?.regional_id) {
      subheader.setBreadcrumbs([
        {
          title: t("sub_header_ops_team")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_REGIONALS_OPS_ADMIN(),
          title: t("sub_header_all_area")
        },
        {
          title: t("sub_header_sub_regional")
        }
      ])
    }
  }, [])

  useEffect(() => {
    if (FieldOfficer?.regionalHead) {
      setDataRh(FieldOfficer?.regionalHead)
    }
  }, [FieldOfficer?.regionalHead])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setIsActiveSearch(true)
      setSearch({ keyword: queryStringObj?.keyword })
    }
  }, [queryStringObj])

  useEffect(() => {
    if (regionalId) {
      const result = location?.search
      setQueryStringObj(urlParams.getUrlParamsObj)
      fetchData(result, regionalId)
    }
  }, [location.search, urlParams.getUrlParamsObj, regionalId])

  function fetchData(param, id) {
    dispatch(getListAssignOpsAdmin(param, id))
  }

  const handleFOPopup = (e) => {
    setShowFOPopup(true)
    setSelectedSubRegional(e?.sub_regional_name)
    setListFO(
      [...(e?.field_officer_list || [])].sort((prev, next) => prev.name?.localeCompare(next.name))
    )
  }

  useEffect(() => {
    if (FieldOfficer?.pageData) {
      setDataList(FieldOfficer.pageData)
    }
  }, [FieldOfficer?.pageData])

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...param,
          sort: param.sortField + "," + param.sortOrder,
          keyword: search.keyword
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...param,
          keyword: search.keyword
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, search]
  )
  const handleResetSearch = () => {
    let param = {
      ...initialFilterTable,
      keyword: ""
    }
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const searchFunc = (values) => {
    setSearch({ keyword: values.keyword })
    setIsActiveSearch(true)
    let param = {
      ...initialFilterTable,
      keyword: values.keyword
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const columnsFO = [
    {
      dataField: "id",
      text: t("table_header_id_fo"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div style={{ height: "fit-content" }}>
            <div className="text-neutral-black font-weight-bolder mb-1 font-size-lg">
              {stringFormatting(e?.code)}
            </div>
          </div>
        )
      },
      sortCaret: sortCaret
    },
    {
      dataField: "name",
      text: t("table_header_name"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div style={{ height: "fit-content" }}>
            <div className="text-neutral-black font-weight-bolder font-size-lg ">
              {stringFormatting(e?.name)}
            </div>
            <div className="text-neutral-black font-weight-medium mb-1 font-size-lg ">
              {stringFormatting(e?.phone_number)}
            </div>
          </div>
        )
      },
      sortCaret: sortCaret
    }
  ]

  const columns = [
    {
      dataField: "sub_regional",
      text: t("label_sub_regional"),
      sort: false,
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "30%" }
      },
      formatExtraData: {
        externalStyle: (e) => (
          <div style={{ height: "fit-content" }}>
            <div className="text-neutral-black font-weight-bolder mb-1 font-size-lg">
              {stringFormatting(e?.sub_regional_name)}
            </div>
            {<div>{stringFormatting(e.regency_list)}</div>}
          </div>
        )
      },
      sortCaret: sortCaret
    },
    {
      dataField: "field_manager",
      text: t("table_header_field_manager"),
      sort: false,
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "23%" }
      },
      formatExtraData: {
        externalStyle: (e) => (
          <div className="h-100 ">
            <div>{stringFormatting(e?.field_manager_name)}</div>
          </div>
        )
      },
      sortCaret: sortCaret
    },
    {
      dataField: "field_supervisor",
      text: t("table_header_field_supervisor"),
      sort: false,
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "23%" }
      },
      formatExtraData: {
        externalStyle: (e) => (
          <div className="h-100 ">
            <div>{stringFormatting(e?.field_supervisor_name)}</div>
          </div>
        )
      },
      sortCaret: sortCaret
    },
    {
      dataField: "field_officer",
      text: t("label_field_officer"),
      sort: false,
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "23%" }
      },
      formatExtraData: {
        externalStyle: (e) => {
          let foArray = (e?.field_officer_list || []).slice(0, 3)
          let foElement = foArray.map((item) => <li key={item.id}>{item.name}</li>)
          if (e.field_officer_list && e.field_officer_list.length > 3) {
            foElement = [
              ...foElement,
              <li
                onClick={() => handleFOPopup(e)}
                className={"text-primary-green"}
                key={foElement.length}>
                {t("label_see_all")}
              </li>
            ]
          }
          return (
            <div className="h-100 ">
              {e.field_officer_list && e.field_officer_list.length > 0 ? <ul>{foElement}</ul> : "-"}
            </div>
          )
        }
      },
      sortCaret: sortCaret
    }
  ]

  return (
    <div style={{ display: "grid", gap: 16 }}>
      <Card>
        <CardBody>
          <div className="d-flex align-items-center">
            <SVG width="48px" height="48px" src={toAbsoluteUrl(ICON_CONSTANTS.REGIONAL_HEAD)} />
            <div className="ml-4 d-flex flex-column items-center">
              <span className="mb-3">
                {t("label_regional_head")} - {stringFormatting(dataRh?.regional_name)}
              </span>
              <h2 className="font-weight-bolder">{stringFormatting(dataRh?.name)}</h2>
            </div>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h2 className="font-weight-bolder mb-5">{t("label_subregional_ops_team")}</h2>
          <div className={"filter-container"}>
            <div className="d-flex w-100 flex-wrap justify-content-between align-items-center mb-10">
              <Search
                customClass={"w-100"}
                isActiveSearch={isActiveSearch}
                placeholder={t("placeholder_search_sub_regional")}
                onSubmitForm={searchFunc}
                initialValues={search}
                name={"keyword"}
                trigerReset={handleResetSearch}
              />
            </div>
          </div>
          {General.loading && General?.actionInitType === FIELD_OFFICER.GET_LIST ? (
            <TableSkeleton column={4} row={10} />
          ) : dataList.length === 0 ? (
            <EmptyCard
              subtitle={isActiveSearch ? t("messages_response_empty_search_subtitle") : ""}
              image={
                isActiveSearch
                  ? ILLUSTRATION_CONSTANTS.NOT_FOUND_REGIONAL
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_FARMER
              }
              body={
                isActiveSearch
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_empty_state", { name: t("label_field_manager") })
              }
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={dataList}
            loadingGetData={General?.loading && General?.actionInitType === FIELD_OFFICER.GET_LIST}
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            currentPage={FieldOfficer?.page?.currentPage ?? 1}
            currentElement={FieldOfficer?.page?.currentElement ?? 10}
            totalCount={FieldOfficer?.page?.totalCount ?? 0}
            ignoreSinglePage
            disabledCentered={true}
            rowClasses={() => {
              return "cursor-pointer"
            }}
          />
        </CardBody>
      </Card>
      <Popup
        show={showFOPopup}
        titleCustom={
          <h4 className="mb-0 font-weight-bolder">
            {t("label_list_field_officer")} - {stringFormatting(selectedSubRegional)}
          </h4>
        }
        bodyCustomClassName={"h-75"}
        size={"lg"}
        contentClassName={"h-75"}
        closeButton={true}
        onCancel={() => {
          setShowFOPopup(false)
        }}
        showButton={false}
        bodyCustom={
          <div>
            <div
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "unset"
              }}
              className={"mb-5"}>
              <TableView
                dataTable={listFO}
                dataSize={listFO.length}
                loadingGetData={false}
                columnProperties={columnsFO}
                callbackAfterPageChange={changePage}
                disablePagination={true}
              />
            </div>
          </div>
        }
      />
    </div>
  )
}